import { createApp } from 'vue'

import App from './App.vue'

// Tokens du design system (vendorisés depuis PreLLM) — chargés en premier
// pour que les composants P* trouvent les CSS variables (:root).
import '@/design-system/tokens/index.css'

createApp(App).mount('#app')
